import { useEffect, useState } from 'react'
import { useAppSelector } from "../../../../../../redux/hooks"
import { getInstancesWithAdd, getInstancesWithAddglobal } from '../request/request';
import axios from 'axios';
import { utils, writeFile } from 'xlsx';
import { useCallback } from 'react';
import { useAuth } from '../../../../auth';
import Swal from 'sweetalert2';

const API_URL = process.env.REACT_APP_API_URL

type LDP = {
  af: string,

  dest: string,

  nexthop: string,

  locallabel: string,

  remotelabel: string,

  use: string
}




export default function LDP(props: any) {
  const Id = useAppSelector(state => state.SuscriptionSlice.id)
  const Type = useAppSelector(state => state.CloudSlice.Type)
  const tenant = useAppSelector(state => state.TenantSlice.id)
  const nameregion = useAppSelector(state => state.RegionSlice.name)
  const FlagReg = useAppSelector(state => state.FlagSlice.value)

  const { currentUser } = useAuth()

  const [Instancia, setInstancia] = useState([{
    id: 0,
    name: " ",
    type: ''
  }])

  const [Busqueda, setBusqueda] = useState("")




  /**********************Llamada a axios para obtener las instancias**********************/
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id !== 0 && Id !== -1 && Type !== 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.LDP')) {

          if (tenant === 0) {
            const instancias = await getInstancesWithAdd(Id, 'Ctx.Troubleshooting.LDP', Type, nameregion);
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            } else {
              setInstancia(instancias.data)
              setBusqueda(instancias.data[0].id)
            }
          }
          else {
            const instancias = await getInstancesWithAddglobal(Id, tenant, 'Ctx.Troubleshooting.LDP', Type, nameregion);
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            } else {
              setInstancia(instancias.data)
              setBusqueda(instancias.data[0].id)
            }
          }
        }
        else if (Id !== 0 && Id !== -1 && Type === 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.LDP')) {

          if (tenant === 0) {
            const instancias = await getInstancesWithAdd(Id, 'Ctx.Troubleshooting.LDP');
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            } else {
              setInstancia(instancias.data)
              setBusqueda(instancias.data[0].id)
            }
          }
          else {
            const instancias = await getInstancesWithAddglobal(Id, tenant, 'Ctx.Troubleshooting.LDP');
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            } else {
              setInstancia(instancias.data)
              setBusqueda(instancias.data[0].id)
            }
          }
        }
      } catch (error) {
        console.error('Error al obtener las cuentas:', error);
      }
    };

    fetchData();
  }, [nameregion]
  )


  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id !== 0 && currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.LDP')) {
          if (tenant === 0) {
            const instancias = await getInstancesWithAdd(Id, 'Ctx.Troubleshooting.LDP');
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            } else {
              setInstancia(instancias.data)
              setBusqueda(instancias.data[0].id)
            }
          }
          else {
            const instancias = await getInstancesWithAddglobal(Id, tenant, 'Ctx.Troubleshooting.LDP');
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            } else {
              setInstancia(instancias.data)
              setBusqueda(instancias.data[0].id)
            }

          }

        }
      } catch (error) {
        console.error('Error al obtener las cuentas:', error);
      }
    };

    fetchData();
  }, [Id]
  )





  //////////////////////////////////////////////////
  const cambiarstate = (e: any) => {
    setBusqueda(e.target.value)
  }




  /*****************************Nuevo**************************************** */
  const [DataLDP, setDataLDP] = useState<LDP[]>([])


  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (props.tab === 5) {

      try {
        if (Busqueda === '') {
          Swal.fire(
            'Oooops!',
            'Please select an Instance',
            'warning',
          )
        }
        else {
          let type
          for (const x of Instancia) {
            if (Number(Busqueda) === x.id) {
              type = x.type
            }
          }

          const body = {
            type: type,
          }


          if (tenant === 0) {
            await axios.post(API_URL + '/v1/troubleshooting/instances/ldp/' + Busqueda, body)
              .then(res => {
                if (res.data.error === 'id instancia invalido') {
                  setDataLDP([])
                }
                else {
                  setDataLDP(res.data)
                }

              })
          }
          else {
            await axios.post(API_URL + '/v1/troubleshooting/instances/ldp/' + Busqueda + '?tenantId=' + tenant, body)
              .then(res => {
                if (res.data.error === 'id instancia invalido') {
                  setDataLDP([])
                }
                else {
                  setDataLDP(res.data)
                }
              })
          }
        }

      }
      catch (error: any) {
        console.log(error)

      }

    }
  }

  useEffect(() => {
    if (Type) {

      setDataLDP([])
    }
    if (tenant) {
      setDataLDP([])
    }
    if (props.tab != 5) {
      setDataLDP([])
    }
  }, [Type, tenant])


  /********************************************* */

  const exportFile = useCallback(() => {
    // Obtén la fecha actual
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Añade ceros a la izquierda si es necesario
    const day = currentDate.getDate().toString().padStart(2, '0');

    // Formatea la fecha en el formato deseado (por ejemplo, YYYY-MM-DD)
    const formattedDate = `${year}-${month}-${day}`;

    /* generate worksheet from state */
    const ws = utils.json_to_sheet(DataLDP);
    /* create workbook and append worksheet */
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "LDP Table");
    utils.sheet_add_aoa(ws, [["AF", "Destination", "Nexthop", "Local Label", "Remote Label", "In Use"]], { origin: "A1" });
    /* export to XLSX */
    let nombre
    for (const x of Instancia) {
      if (Number(Busqueda) === x.id) {
        nombre = x.name
      }
    }
    writeFile(wb, nombre + "_LDP_" + formattedDate + ".xlsx");
  }, [DataLDP]);


  return (
    <>
      <div style={{ marginTop: '15px' }} className="f-titulo fs-md mb-3 text-marino text-center">
        LDP Table
      </div>
      <div
        className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid '
        id='kt_create_account_stepper'
      >
        {/* begin::Aside*/}
        <div className='card d-flex justify-content-center justify-content-xl-start flex-row-auto w-100 w-xl-300px w-xxl-400px me-9 border border-gray-300' style={{ marginBottom: '20px' }}>
          {/* begin::Wrapper*/}
          <div className='card-body px-6 px-lg-10 px-xxl-15 py-20'>
            {/* begin::Nav*/}
            <div className='stepper-nav'>
              {/* begin::Step 1*/}
              <div className='stepper-item current' data-kt-stepper-element='nav'>
                {/* begin::Wrapper*/}
                <div className='stepper-wrapper'>
                  {/* begin::Label*/}
                  <div className='stepper-label'>
                    <div className="d-flex flex-wrap fw-bold fs-6 mb-4 pe-2 flex-center">
                      <div className="d-flex flex-column flex-row-auto">
                        <label className='form-label f-bold fs-p text-marino required form-label' >Instance</label>
                        <select className="custom-select w-200px" aria-label="Select example"
                          onChange={cambiarstate} value={Busqueda}>
                          {Instancia.length === 0 && <option hidden>No data</option>}
                          <option hidden>Select an Instance </option>
                          {Id !== 0 && Instancia.map((ins: any, i) =>
                            <option key={i} value={ins.id}>{ins.name}</option>
                          )
                          }
                          {Id === -1 && Type === 'CloudGlobal' && Instancia.map((ins: any, i) =>
                            <option key={i} value={ins.id}>{ins.name}</option>
                          )
                          }

                        </select>
                      </div>

                      <div className='w-30px'></div>
                      <br />
                      <br />

                      <div className="d-flex flex-column flex-row-auto  ">
                        <br />
                        <button
                          type='submit'
                          onClick={handleSubmit}
                          className='btn-light-marino'
                        >
                          <span className='indicator-label'>Search</span>
                        </button>
                      </div>

                      <div className='w-30px'></div>
                      <div className='text-center'>
                        <br />
                        <button className="btn-light-marino" onClick={exportFile}> <i className="bi bi-download"></i>Export Excel </button>

                      </div>


                    </div>
                    {/*<div  className="d-flex flex-column flex-row-auto  ">
                        <br />
                        <button className="btn btn-light-primary" onClick={exportFile}> <i className="bi bi-download"></i>Export Excel </button>

                                  </div>*/}
                  </div>
                  {/* end::Label*/}
                </div>
                {/* end::Wrapper*/}

              </div>
              {/* end::Step 1*/}

            </div>
            {/* end::Nav*/}
          </div>
          {/* end::Wrapper*/}
        </div>
        {/* begin::Aside*/}

        <div className='black-background d-flex flex-row-fluid  bg-body rounded border ' style={{ marginBottom: '20px' }}>
          <div className='w-100'>
            <div className='pb-10 pb-lg-15'>
              <div className="card-body card-scroll  h-300px">
                <table className="w-full f-parrafo  caption-bottom  custom-table"  >
                  <thead className="table-header-light bg-marino">
                    <tr >
                      <th className='table-cell'>AF</th>
                      <th className='table-cell'>Destination</th>
                      <th className='table-cell'>Nexthop</th>
                      <th className='table-cell'>Local Label</th>
                      <th className='table-cell'>Remote Label</th>
                      <th className='table-cell'>In Use </th>
                    </tr>
                  </thead>
                  <tbody style={{ marginTop: '0px' }}>
                    {DataLDP !== null &&
                      DataLDP?.map((d, i) => (
                        <>
                          <tr key={i} className='table-row'>

                            <td className='table-cell'>{d.af}</td>
                            <td className='table-cell'>{d.dest}</td>
                            <td className='table-cell'>{d.nexthop}</td>
                            <td className='table-cell'>{d.locallabel}</td>
                            <td className='table-cell'>{d.remotelabel}</td>
                            <td className='table-cell'>{d.use}</td>


                          </tr>


                        </>
                      ))}

                  </tbody>

                </table>
              </div>
              {Id === -1 && Type !== 'CloudGlobal' &&
                <table className="table table-striped gy-7 gs-7">
                  <tbody>
                    <div className="text-center">
                      Select a Cloud with available subscriptions
                    </div>
                  </tbody>
                </table>}

            </div>

          </div>

        </div>
      </div>
    </>
  )

}